module.exports = __webpack_public_path__ + "static/media/icon5.75f9f0c1.svg";